export default __webpack_public_path__ + "static/media/NoirPro-Regular.437841a0.woff";